/* eslint-disable react-refresh/only-export-components */
import { Input, type InputProps, type InputRef } from "antd";
import { forwardRef, memo } from "react";

export interface CustomInputPasswordProps extends InputProps {}

const CustomInputPassword = forwardRef<InputRef, CustomInputPasswordProps>(
  ({ className = "", ...restParams }, ref) => {
    return (
      <Input.Password
        {...restParams}
        ref={ref}
        className={`px-2 py-4 ${className}`.trim()}
      />
    );
  },
);

CustomInputPassword.displayName = "CustomInputPassword";

export default memo(CustomInputPassword);
